<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <!-- TABLA DOCUMENTO -->
          <template>
            <v-tabs v-model="active_tab">
              <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
              <v-tab
                v-for="(tab, index) in tabs"
                :key="index"
                @click="selected(tab)"
                >{{ tab }}</v-tab
              >
              <v-tabs-items>
                <!-- TAB DE RELATORES -->
                <v-card flat v-if="tabSelected == 'Relator'">
                  <grid-relator
                    :key="gridDocumento"
                    :rowsTable="rowsTable"
                    :contratoId="contratoId"
                  ></grid-relator>
                </v-card>
                <!-- TAB DE SESIONES FORMATIVAS -->
                <v-card flat v-if="tabSelected == 'Sesiones Formativas'">
                  <grid-sesiones-formativas
                    :key="gridDocumento2"
                    :rowsTable="rowsTable"
                    :contratoId="contratoId"
                  ></grid-sesiones-formativas>
                </v-card>
                <!-- TAB DE EVALUACION RELATORES -->
                <v-card flat v-if="tabSelected == 'Evaluación Relatores'">
                  <grid-evaluacion-relator
                    :key="gridDocumento3"
                    :rowsTable="rowsTable"
                    :contratoId="contratoId"
                  ></grid-evaluacion-relator>
                </v-card>
              </v-tabs-items>
            </v-tabs>
          </template>
          <!-- TABLA DOCUMENTO -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import GridRelator from "@/modules/capacitacion/views/relator/GridRelator.vue";
import GridSesionesFormativas from "@/modules/capacitacion/views/relator/GridSesionFormativa.vue";
import GridEvaluacionRelator from "@/modules/capacitacion/views/relator/GridEvaluacionRelator.vue";

export default {
  name: "relatores-seleccion-tab",

  components: {
    GridRelator,
    GridEvaluacionRelator,
    GridSesionesFormativas,
  },

  props: {
    tabDefecto: String,
  },

  data() {
    return {
      tabs: ["Relator", "Sesiones Formativas", "Evaluación Relatores"],
      tabSelected: "",
      proveedor: {},
      rowsTable: [5],
      contratoId: "",
      tabSelect: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      usuarioLogged: "",
      gridDocumento: 20,
      gridDocumento2: 20,
      activeTab: "",
      index: "",
      active_tab: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.tabSelected = this.tabDefecto;
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
      this.gridDocumento2 += 22;
      this.gridDocumento3 += 22;
    },
    selected(tab) {
      this.$store.commit("sub_tab_state", tab);
      this.tabSelected = tab;
    },
  },
};
</script>
